var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('UserHeader',{staticClass:"user-info",attrs:{"id":_vm.$route.params.id},on:{"basic-info":function (data) { return _vm.basicInfo = data; }}}),_c('router-view',{attrs:{"basic-info":_vm.basicInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }